import { render, staticRenderFns } from "./MainEnergy.vue?vue&type=template&id=4af6fb1b&scoped=true&"
import script from "./MainEnergy.vue?vue&type=script&lang=js&"
export * from "./MainEnergy.vue?vue&type=script&lang=js&"
import style0 from "./MainEnergy.vue?vue&type=style&index=0&id=4af6fb1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6fb1b",
  null
  
)

export default component.exports